import { appData } from '@/mocks/homeData';

export default function SectionApp() {
  return (
    <section id="app" className="w-full py-14 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full max-w-[500px] lg:max-w-none">
            <div className="lg:hidden mb-8">
              <img
                src={appData.appImage}
                alt="2828电影网APP界面展示"
                className="w-full max-w-[280px] mx-auto h-auto object-contain rounded-2xl"
                loading="lazy"
              />
            </div>

            <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950 mb-3 text-center lg:text-left">
              {appData.title}
            </h2>
            <p className="text-sm md:text-base text-foreground-600 mb-8 text-center lg:text-left">
              {appData.subtitle}
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-8">
              {appData.features.map((feat) => (
                <div key={feat} className="flex items-center gap-2.5">
                  <div className="w-6 h-6 rounded-full bg-accent-100 flex items-center justify-center flex-shrink-0">
                    <i className="ri-check-line text-sm text-accent-600"></i>
                  </div>
                  <span className="text-sm text-foreground-700 whitespace-nowrap">
                    {feat}
                  </span>
                </div>
              ))}
            </div>

            <div className="flex flex-col sm:flex-row items-center gap-4 justify-center lg:justify-start">
              <div className="w-32 h-32 bg-background-50 border border-background-200/70 rounded-xl p-2 flex-shrink-0">
                <img
                  src={appData.qrImage}
                  alt="扫码下载2828电影网APP"
                  className="w-full h-full object-contain"
                  loading="lazy"
                />
              </div>
              <div className="text-center sm:text-left">
                <p className="text-sm font-medium text-foreground-800 mb-1">
                  扫码下载APP
                </p>
                <p className="text-xs text-foreground-500">
                  支持 iOS / Android
                </p>
              </div>
            </div>
          </div>

          <div className="flex-1 hidden lg:flex justify-center">
            <div className="relative">
              <div className="absolute -inset-8 bg-gradient-to-r from-accent-500/20 to-primary-500/20 rounded-[40px] blur-3xl"></div>
              <img
                src={appData.appImage}
                alt="2828电影网APP界面展示"
                className="relative w-full max-w-[320px] h-auto object-contain rounded-2xl"
                loading="lazy"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}